import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectIds } from '../../../../selectors/ids';
import { HeaderCell, HeaderContent, HeaderRow } from '../../../../components/Header';
import { HeaderFieldContainer, HeaderRowTitleContainer } from '../../../Table/parts/Field';
import { selectOffers } from '../../../../selectors/offers';
import { IOffer } from '../../../../types/offer';
import { OfferContext } from '../../../../utils/offerContext';

export interface IHeaderRowContainerProps {
  headerRowRef: React.Ref<HTMLDivElement>;
  position: number;
  prev: React.ReactNode;
  sticky?: boolean;
}

export const HeaderRowContainer = ({
  position,
  headerRowRef,
  prev,
  sticky,
}: IHeaderRowContainerProps): React.JSX.Element => {
  const ids = useSelector(selectIds);
  const offers = useSelector(selectOffers);

  return (
    <HeaderContent sticky={sticky}>
      <HeaderRow ref={headerRowRef} key="titleCell" position={position} sticky={sticky}>
        <HeaderCell position={0}>
          <HeaderRowTitleContainer />
        </HeaderCell>
        {ids.map(id => {
          const offer: IOffer = offers[id];
          const { published } = offer;

          return (
            <OfferContext.Provider key={`header-cell_${id}`} value={offer}>
              <HeaderCell position={position} published={published}>
                <HeaderFieldContainer sticky={sticky} />
              </HeaderCell>
            </OfferContext.Provider>
          );
        })}
      </HeaderRow>
      {prev}
    </HeaderContent>
  );
};
